import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface ColumnSelectProps {
  label: string;
  value: string;
  headers: string[];
  onChange: (value: string) => void;
  required?: boolean;
  id?: string;
  'data-testid'?: string;
}

/**
 * Searchable column selector with limited dropdown height.
 * Uses MUI Autocomplete for type-ahead filtering of column headers.
 */
const ColumnSelect: React.FC<ColumnSelectProps> = ({
  label,
  value,
  headers,
  onChange,
  required = false,
  id,
  ...props
}) => {
  return (
    <Autocomplete
      id={id}
      data-testid={props['data-testid']}
      options={headers}
      value={value || null}
      onChange={(_event, newValue) => {
        onChange(newValue || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={required ? `${label} *` : label}
          required={required}
          size="small"
        />
      )}
      ListboxProps={{
        style: { maxHeight: 200 },
      }}
      clearOnEscape
      openOnFocus
      size="small"
      sx={{ maxWidth: 400 }}
      fullWidth
    />
  );
};

export default ColumnSelect;
